import React, { Component, Fragment } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import DOMPurify from 'dompurify';
import { Link } from 'react-router-dom';
import Header from '../components/Header';

class Home extends Component {
  state = {
    news: null,
    isLoading: false,
    error: [],
  };

  componentDidMount() {
    this.setState({
      isLoading: true,
    });
    axios
      .get(`https://www.acertarorumo.pt/wp-json/wp/v2/posts/${this.props.match.params.id}`)
      .then((response) => {
        this.setState({
          news: response.data,
          isLoading: false,
        });
      })
      .catch((error) =>
        this.setState({
          error: error,
          isLoading: false,
        })
      );
  }

  render() {
    const { news, isLoading } = this.state;

    // console.log(news);

    let noticia_info =
      news !== null && isLoading === false ? (
        <div className="blackline">
          <h2>{news.title.rendered}</h2>
          <p className="big-text">{dayjs(news.date).format('DD/MM/YYYY')}</p>
        </div>
      ) : (
        <div>
          <p>A carregar...</p>
        </div>
      );

    let noticia_body =
      news !== null && isLoading === false ? (
        <div
          className="blackline medium-text"
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(`${news.content.rendered}`),
          }}
        />
      ) : (
        <p>A carregar...</p>
      );

    return (
      <Fragment>
        <Header title={<Link to="/">Notícias</Link>} />

        <section className="content">
          <div className="noticia-info">{noticia_info}</div>
          <div className="noticia-body">{noticia_body}</div>
        </section>
      </Fragment>
    );
  }
}

export default Home;
